import { z } from "zod";
import { zStringDate, zStringId, zTimestamps } from "../../utils";
import { zServicePackage } from "../services/service-package-resource";
import { zUserSnippet } from "../users/user-snippet-resource";
import { zServiceDescriptiveFields } from "../services/service-resource";
import { ServiceProjectStatusEnum } from "./service-project-statics";

export const zServiceProject = z.object({
  _id: zStringId(),
  serviceId: zStringId(),
  serviceDetails: z.object(zServiceDescriptiveFields()),
  servicePackageId: zStringId(),
  servicePackageDetails: zServicePackage,
  orderNumber: z.number(),
  status: z.nativeEnum(ServiceProjectStatusEnum),
  statusUpdates: z
    .object({
      from: z.nativeEnum(ServiceProjectStatusEnum),
      to: z.nativeEnum(ServiceProjectStatusEnum),
      byUserId: zStringId().optional(),
    })
    .array(),
  closingReason: z.string().optional(),
  acceptedAt: zStringDate().optional(),
  dueAt: zStringDate(),
  deliverablesCompletion: z.array(
    z.object({
      _id: zStringId(),
      name: z.string(),
      index: z.number(),
      isCompleted: z.boolean(),
      completeAt: zStringDate().optional(),
    }),
  ),
  ...zTimestamps(),

  tasksInfo: z.object({
    total: z.number(),
    completed: z.number(),
  }),

  clientDoc: zUserSnippet,
  professionalDoc: zUserSnippet,
  clientRating: z.number().optional(),
  professionalRating: z.number().optional(),
});

export type ServiceProject = z.infer<typeof zServiceProject>;
